//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create log ----------------
export const handleListBookTranslation = (bookId) => async (dispatch) => {
	try {
		const data = await apis.get('booksRDS', `/list_book_translation/${bookId}`)
		if(data&&data.success){
			dispatch(Actions.setBookTranslationContent({
				book_id:bookId,
				data:data.data
			}))
		}
		return data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'listing book translation',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'LIST_BOOK_TIPS'
            });
		}
	}
	return {}
};
export const handleDeletePageTranslation = (id) => async (dispatch) => {
	try {
		const data = await apis.del('booksRDS', `/delete_book_translation/${id}`)
		if(data&&data.success){
			const { chapter , page } = data.data;
			dispatch(Actions.removePageTranslations({book_id:chapter,page_id:page}))
		}
		return data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'deleting page translation',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'DELETE_PLACEMENT_TEACHER'
            });
		}
	}
	return {}
};
export const handleCreateOrUpdatePageTranslation = (pageData) => async (dispatch) => {
	try {
		const data = await apis.put('booksRDS', `/modify_book_translation`,{
			body:pageData
		})
		if(data&&data.success){
			const { chapter , page } = data.data;
			dispatch(Actions.updateBookTranslations({book_id:chapter,page_id:page,data:data.data}))
		}
		return data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'creating or updating page translation',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'CREATE_ORGANIZATION_USER_PREFERENCE_TIPS'
            });
		}
	}
	return {}
};

export const handleUpdateGrammarContent = (payload) => async (dispatch) => {
	try {
	  const  data  = await apis.put("booksRDS", `/grammar_content/modify_grammar_content`, {
		body: payload
	  });
	  if(data&&data.success){
		dispatch(Actions.updateBookGrammarContent(data.data))
	  }
	} catch (error) {
	  if (error && error.message != "Network Error") {
		logToSentry({
                message: 'updating grammar content',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'UPDATE_GROUP_CLASS'
            });
	  }
	}
  };
  export const handleListGrammarContent = (id) => async (dispatch) => {
	dispatch(Actions.clearBookGrammarContent())
	try {
	  const pge_grammars = await apis.get("booksRDS", `/grammar_content/list_page_grammar_content/${id}`);
	  if(pge_grammars&&pge_grammars.success){
		dispatch(Actions.setBookGrammarContent(pge_grammars.data))
	  }
	 return pge_grammars;
	} catch (error) {
	  if (error && error.message != "Network Error") {
		logToSentry({
                message: 'listing grammar content',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'LIST_GROUP_CLASS'
            });
	  }
	}
  };
  export const handleDeleteGrammarContent = (id) => async (dispatch) => {
	try {
	  const pge_grammars = await apis.del("booksRDS", `/grammar_content/delete_grammar_content/${id}`);
	  if(pge_grammars&&pge_grammars.success){
		dispatch(Actions.removeBookGrammarContent(pge_grammars.data))
	  }
	  return pge_grammars;
	} catch (error) {
	  if (error && error.message != "Network Error") {
		logToSentry({
                message: 'deleting grammar content',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'DELETE_GROUP_CLASS'
            });
	  }
	}
  };
export const handleUpdateVocabContent = (payload) => async (dispatch) => {
	try {
	  const  data  = await apis.put("booksRDS", `/vocab_content/modify_vocab_content`, {
		body: payload
	  });
	  if(data&&data.success){
		dispatch(Actions.updateBookvocabContent(data.data))
	  }
	} catch (error) {
	  if (error && error.message != "Network Error") {
		logToSentry({
                message: 'updating vocab content',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'UPDATE_VOCABULARY_CONTENT'
            });
	  }
	}
  };
  export const handleListVocabContent = (id) => async (dispatch) => {
	dispatch(Actions.clearBookvocabContent())
	try {
	  const pge_grammars = await apis.get("booksRDS", `/vocab_content/list_page_vocab_content/${id}`);
	  if(pge_grammars&&pge_grammars.success){
		dispatch(Actions.setBookvocabContent(pge_grammars.data))
	  }
	 return pge_grammars;
	} catch (error) {
	  if (error && error.message != "Network Error") {
		logToSentry({
                message: 'listing vocab content',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'LIST_VOCABULARY_CONTENT'
            });
	  }
	}
  };
  export const handleDeleteVocabContent = (id) => async (dispatch) => {
	try {
	  const pge_grammars = await apis.del("booksRDS", `/vocab_content/delete_vocab_content/${id}`);
	  if(pge_grammars&&pge_grammars.success){
		dispatch(Actions.removeBookvocabContent(pge_grammars.data))
	  }
	  return pge_grammars;
	} catch (error) {
	  if (error && error.message != "Network Error") {
		logToSentry({
                message: 'deleting vocab content',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'DELETE_VOCABULARY_CONTENT'
            });
	  }
	}
  };